import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {ManualScrollWrapperComposer} from "./manual-scroll-wrapper.composer";
import {ManualScrollerWrapperArrows} from "./manual-scroll-wrapper.arrows";

export class ManualScrollerWrapperProps extends BaseProps {
  isSmallView: Boolean;
  offset: Number;
  position: Number;
  wrapperHeight: Number;
  isUpScrollAllow: Boolean;
  isDownScrollAllow: Boolean;
  shouldRenderArrows: Boolean;
  shouldRenderSponsorshipWrapper: Boolean;
  contentRef: HTMLElement;
  containerRef: HTMLElement;
  onUpClick: Function;
  onDownClick: Function;
  handleContentResize: Function;
  children: React.Children;
}

export const ManualScrollerWrapper = ManualScrollWrapperComposer(React.forwardRef((props: ManualScrollerWrapperProps, ref) => {
  const isLargeContainer = props.offset > 0 && !props.shouldRenderArrows;

  const wrapperProps = {
    className: ['manual-scroll-wrapper-container', props.isSmallView ? 'manual-scroll-wrapper-small-view' : '',
      props.shouldRenderSponsorshipWrapper ? 'manual-scroll-wrapper-container-with-sponsorship' : '',
      isLargeContainer ? 'manual-scroll-wrapper-container-no-arrows' : ''].join(' ')
  }

  const containerProps = {
    className: 'manual-scroll-wrapper-content-container',
    ref,
  }

  const contentProps = {
    className: 'manual-scroll-wrapper-content',
    onLoad: () => props.handleContentResize(),
    style: {
      top: props.position
    }
  }

  const arrowsProps = {
    isUpScrollAllow: props.isUpScrollAllow,
    isDownScrollAllow: props.isDownScrollAllow,
    onUpClick: props.onUpClick,
    onDownClick: props.onDownClick,
  }

  return (
    <div {...wrapperProps}>
      <div {...containerProps}>
        <div {...contentProps}>
          {
            props.children
          }
        </div>
      </div>
      {
        props.shouldRenderArrows && <ManualScrollerWrapperArrows {...arrowsProps}/>
      }
    </div>
  )
}));
